import { shape, bool } from 'prop-types';

export default shape({
    isB2B: bool,
    isGuest: bool,
    isLogged: bool,
});
